import { mpx } from '@didi/es-mpx-creator'
import {
  GET_PAY_TYPE,
  MAKE_ORDER,
  MAKE_SCRAMBLE_ORDER,
  CHANGE_TICKET_ORDER,
  IDENTITY_INFO_CHECK,
  ORDER_BASE_INFO,
  GET_CONTACT_INFO,
  SAVE_CONTACT_INFO,
  RE_CHECKED_PROTOCOL,
  RE_TRAIN_CHECKED_PROTOCOL,
  GET_CHECKED_PROTOCOL,
  GET_TRAIN_CHECKED_PROTOCOL,
  MAKE_UNION_ORDER
} from '@/api/urls';
import { trackingInfo } from '@/common/jump';

export const getOrderBaseInfo = data => {
  return mpx.$http.post(ORDER_BASE_INFO, { data })
}

/**
 * @method 支付方式鉴权
 * @param {*} data
 * @property {string} params.train_code  - 车次号
 * @property {string} params.institution_id - 差旅制度
 * @property {int} params.from_city_id  - 出发城市id
 * @property {int} params.to_city_id - 到达城市id
 * @property {string} params.seat_type  - 座位类型（一等、二等）
 * @property {int} params.cost - 订单金额（单位：分）
 * @property {string} params.meeting_time  - 出发时间
 * @property {string} params.pre_order_id - 改签时必传(原订单号)
 * @property {string} params.ticket_info - 车票信息
 * @returns
 */
export const getPayType = data => {
  return mpx.$http.post(GET_PAY_TYPE, { data })
}

/**
 * @method 下单
 * @param {*} data
 * @property {string} data.train_no - 全车次或站车次
 * @property {string} data.institution_id - 差旅制度
 * @property {int} data.from_city_id - 出发城市
 * @property {int} data.to_city_id - 目的城市
 * @property {string} data.seat_type - 席座类型
 * @property {string} data.start_date - 出发日期
 * @property {string} data.remark - 原因（改签需要）
 * @property {string} data.train_code - 车次
 * @property {string} data.train_type_code -
 * @property {string} data.from_station_name - 上车站名
 * @property {string} data.to_station_name - 下车站名
 * @property {string} data.choose_seats - 座位串
 * @property {string} data.from_station_telecode - 出发站电码
 * @property {string} data.to_station_telecode - 目的地站电码
 * @property {string} data.start_time - 出发时间
 * @property {int} data.personal_pay - 个人支付金额，单位：分
 * @property {int} data.total_price - 总金额，单位：分
 * @property {string} data.order_id - 改签时必传(原订单号)
 * @property {string} data.sequence_no - supplier_order_id
 * @property {string} data.train_secrets - 车次加密秘钥
 * @property {string} data.ticket_id - 车票id
 * @property {string} data.contact_phone - 联系人手机号（航天华友）
 * @property {string} data.tickets - 车票信息
 *
 * @param {string} tickets
 * @property {string} tickets.passenger_name - 	乘客名字
 * @property {int} tickets.special_flag - 是否为静音车厢 1为使
 * @property {string} tickets.encrypt_passenger_id_no - 加密身份证号
 * @property {string} tickets.passenger_id_type - id类别
 * @property {string} tickets.ticket_price - 票种，如1是成人票
 * @returns
 */

export const makeOrder = data => {
  const params = {
    ...data,
    tracking_info: trackingInfo()
  };
  return mpx.$http.post(MAKE_ORDER, { data: params });
}

export const makeUnionOrder = data => {
  const params = {
    ...data,
    tracking_info: trackingInfo()
  };
  return mpx.$http.post(MAKE_UNION_ORDER, { data: params });
}

export const makeScrambleOrder = data => {
  const params = {
    ...data,
    tracking_info: trackingInfo()
  };
  return mpx.$http.post(MAKE_SCRAMBLE_ORDER, { data: params, timeout: 60000  });
};

export const identityInfoCheck = data => {
  return mpx.$http.post(IDENTITY_INFO_CHECK, { data })
}

/**
 * @method 改签
 * @param {*} data  与下单一致
 * @returns
 */
export const changeTicketOrder = data => {
  const params = {
    ...data,
    tracking_info: trackingInfo()
  };
  return mpx.$http.post(CHANGE_TICKET_ORDER, { data: params });
}

/**
 * @method 保存出行人信息
 * @param {*} data
 * @property {string} data.supplier_id - 	供应商ID
 * @property {string} data.passenger_id - 供应商乘客id
 * @property {string} data.passenger_name - 	乘客真实名字
 * @property {string} data.id_type - 	证件类型
 * @property {string} data.id_no - 	乘客证件号(带星加密)
 * @property {string} data.real_id_no - 	乘客证件号(不带星加密)
 *
 * @returns
 */

export const saveContactInfo = data => {
  return mpx.$http.post(SAVE_CONTACT_INFO, { data })
}

/**
 * @method 获取出行人信息
 * @param {*} data
 * @returns
 */
export const getContactInfo = data => {
  return mpx.$http.post(GET_CONTACT_INFO, { data })
}

/**
 * @method 获取下单协议授权信息
 * @param {*} data
 * @returns
 */

export const rememberCheckedProtocol = data => {
  return mpx.$http.post(RE_CHECKED_PROTOCOL, { data });
};
export const rememberTrainCheckedProtocol = data => {
  return mpx.$http.post(RE_TRAIN_CHECKED_PROTOCOL, { data });
};

export const getCheckedProtocol = data => {
  return mpx.$http.post(GET_CHECKED_PROTOCOL, { data });
};

export const getTrainCheckedProtocol = data => {
  return mpx.$http.post(GET_TRAIN_CHECKED_PROTOCOL, { data });
};
